export default __webpack_public_path__ + "static/media/Group 12507.ea7ad92b.svg";